import React, { useEffect, useState } from 'react';
import { INPUT_CLS } from './storeSettingsForm';

/**
 * Αριθμός ρύθμισης που αποθηκεύεται όταν φύγει η εστίαση (ή με Enter) — όχι σε κάθε πλήκτρο:
 * το «35» έστελνε πριν δύο PATCH, πρώτα «3» και μετά «35». Οι στήλες numeric έρχονται από τον
 * pg ως κείμενο («50.00»), γι' αυτό η σύγκριση γίνεται σε αριθμούς. Εμφάνιση: όπως τα πεδία του «Φύλλου».
 */
interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'min' | 'max' | 'type'> {
  value: number | string;
  min?: number;
  max?: number;
  onCommit: (value: number) => void;
}

const CommitNumberInput: React.FC<Props> = ({ value, min, max, onCommit, className = `${INPUT_CLS} tabular-nums`, ...rest }) => {
  const current = Number(value);
  const shown = Number.isFinite(current) ? String(current) : '';
  const [draft, setDraft] = useState(shown);
  useEffect(() => setDraft(shown), [shown]);

  const commit = () => {
    const raw = Number(draft);
    if (draft.trim() === '' || !Number.isFinite(raw)) {
      setDraft(shown);
      return;
    }
    let next = raw;
    if (min !== undefined) next = Math.max(min, next);
    if (max !== undefined) next = Math.min(max, next);
    setDraft(String(next));
    if (next !== current) onCommit(next);
  };

  return (
    <input
      {...rest}
      className={className}
      type="number"
      min={min}
      max={max}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur();
      }}
    />
  );
};

export default CommitNumberInput;
